// removed by extract-text-webpack-plugin
module.exports = {"container":"_1e3BTLlG9j6k9B2fawlrWb","phoneType":"tfIL5srntceQwbk8aOSkk","phoneNumber":"_13js92I3qRF-EMY1KBy-nJ"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-429efc7c","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/shared/SearchContacts/SearchMode/PhoneNumber.less
// module id = O71l
// module chunks = 1